module.exports = __webpack_public_path__ + "img/save-white.a1507b10.svg";